
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CbxVariablesModule } from '../../store/modules/CbxVariablesModule';
import ProductDetailsModule from '../../store/modules/ProductDetailsModule';

@Component({
    name: 'DetailsColopConfiguratorFrame',
    components: {},
})
export default class DetailsColopConfiguratorFrame extends Vue {
    @Prop({ type: String, required: false }) private selectedTemplate: string;

    private checkoutMode: string = "direct";
    private producttype: string = "stamps";
    private mediaId: string = "nydan";
    private language: string = "dk_DK";

    private get translationsReady(): boolean {
        return this.$root.$data.translationsLoaded === true;
    }

    get itemnumber(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) return ProductDetailsModule.SELECTED_VARIANT?.sku;
        else return ProductDetailsModule.PRODUCT?.id ?? '';
    }

    get name(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) return ProductDetailsModule.SELECTED_VARIANT?.name;
        else return ProductDetailsModule.PRODUCT?.name ?? '';
    }

    get frameSrc(): string {
        return `https://nydan-c6i.colop.com/creator?templateIds=` + this.templates 
        + `&padColors=` + this.availablePadColorsCreator 
        + `&padColorSelected=` + this.availablePadColorsCreator.split(',')[0] 
        + `&productId=` + this.itemnumber + `&productName=` + this.name 
        + `&returnUrl=` + `${window.location.protocol + '//' + window.location.host + window.location.pathname}?colop_callback=${CbxVariablesModule.VARIABLES.cartId}`
        + `&language=` + "dk"
        + `&cartValues=` + this.itemnumber;
    }

    get templates(): string {
        if (this.selectedTemplate)
            return this.selectedTemplate;

        return ProductDetailsModule.COLOP_CONFIGURATION?.templates?.map((t: string) => t.indexOf(".cbt") > 0 ? t.substring(0, t.indexOf(".cbt")) : t)?.join(",") ?? "";
    }
        
    get availablePadColorsCreator(): string {
        return ProductDetailsModule.COLOP_CONFIGURATION?.colors?.join(",") ?? "";
    }
}
